var _jsxFileName = "C:\\github\\os\\react-most-wanted\\packages\\rmw-shell\\src\\config\\menuItems.js";
import AccountBoxIcon from '@material-ui/icons/AccountBox';
import Brightness2 from '@material-ui/icons/Brightness2';
import Brightness7 from '@material-ui/icons/Brightness7';
import Business from '@material-ui/icons/Business';
import ChatIcon from '@material-ui/icons/Chat';
import DaschboardIcon from '@material-ui/icons/Dashboard';
import GroupIcon from '@material-ui/icons/Group';
import InfoOutlined from '@material-ui/icons/InfoOutlined';
import LanguageIcon from '@material-ui/icons/Language';
import ListIcon from '@material-ui/icons/List';
import LockIcon from '@material-ui/icons/Lock';
import PersonIcon from '@material-ui/icons/Person';
import React from 'react';
import Security from '@material-ui/icons/Security';
import SettingsIcon from '@material-ui/icons/SettingsApplications';
import StyleIcon from '@material-ui/icons/Style';
import VerticalAlignBottomIcon from '@material-ui/icons/VerticalAlignBottom';
import allLocales from './locales';
import allThemes from './themes';

const getMenuItems = props => {
  const locale = props.locale,
        updateTheme = props.updateTheme,
        switchNightMode = props.switchNightMode,
        updateLocale = props.updateLocale,
        intl = props.intl,
        themeSource = props.themeSource,
        auth = props.auth,
        isGranted = props.isGranted,
        deferredPrompt = props.deferredPrompt,
        isAppInstallable = props.isAppInstallable,
        isAppInstalled = props.isAppInstalled,
        isAuthMenu = props.isAuthMenu,
        handleSignOut = props.handleSignOut;
  const isAuthorised = auth.isAuthorised;
  const themeItems = allThemes.map(t => {
    return {
      value: undefined,
      visible: true,
      primaryText: intl.formatMessage({
        id: t.id
      }),
      onClick: () => {
        updateTheme(t.id);
      },
      leftIcon: /*#__PURE__*/React.createElement(StyleIcon, {
        style: {
          color: t.color
        },
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 48,
          columnNumber: 17
        }
      })
    };
  });
  const localeItems = allLocales.map(l => {
    return {
      value: undefined,
      visible: true,
      primaryText: intl.formatMessage({
        id: l.locale
      }),
      onClick: () => {
        updateLocale(l.locale);
      },
      leftIcon: /*#__PURE__*/React.createElement(LanguageIcon, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 60,
          columnNumber: 17
        }
      })
    };
  });

  if (isAuthMenu) {
    return [{
      value: '/my_account',
      primaryText: intl.formatMessage({
        id: 'my_account'
      }),
      leftIcon: /*#__PURE__*/React.createElement(AccountBoxIcon, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 69,
          columnNumber: 19
        }
      })
    }, {
      value: '/signin',
      onClick: handleSignOut,
      primaryText: intl.formatMessage({
        id: 'sign_out'
      }),
      leftIcon: /*#__PURE__*/React.createElement(LockIcon, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 75,
          columnNumber: 19
        }
      })
    }];
  }

  return [{
    value: '/dashboard',
    visible: isAuthorised,
    primaryText: intl.formatMessage({
      id: 'dashboard'
    }),
    leftIcon: /*#__PURE__*/React.createElement(DaschboardIcon, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 85,
        columnNumber: 17
      }
    })
  }, {
    visible: isAuthorised,
    primaryText: intl.formatMessage({
      id: 'chats'
    }),
    primaryTogglesNestedList: true,
    leftIcon: /*#__PURE__*/React.createElement(ChatIcon, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 91,
        columnNumber: 17
      }
    }),
    nestedItems: [{
      value: '/chats',
      visible: isAuthorised,
      primaryText: intl.formatMessage({
        id: 'private'
      }),
      leftIcon: /*#__PURE__*/React.createElement(PersonIcon, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 97,
          columnNumber: 21
        }
      })
    }, {
      value: '/public_chats',
      visible: isAuthorised,
      primaryText: intl.formatMessage({
        id: 'public'
      }),
      leftIcon: /*#__PURE__*/React.createElement(GroupIcon, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 103,
          columnNumber: 21
        }
      })
    }]
  }, {
    value: '/companies',
    visible: isGranted('read_companies'),
    primaryText: intl.formatMessage({
      id: 'companies'
    }),
    leftIcon: /*#__PURE__*/React.createElement(Business, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 111,
        columnNumber: 17
      }
    })
  }, {
    value: '/tasks',
    visible: isAuthorised,
    primaryText: intl.formatMessage({
      id: 'tasks'
    }),
    leftIcon: /*#__PURE__*/React.createElement(ListIcon, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 117,
        columnNumber: 17
      }
    })
  }, {
    value: '/about',
    visible: isAuthorised,
    primaryText: intl.formatMessage({
      id: 'about'
    }),
    leftIcon: /*#__PURE__*/React.createElement(InfoOutlined, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 123,
        columnNumber: 17
      }
    })
  }, {
    visible: isAuthorised,
    // In prod: isGranted('administration'),
    primaryTogglesNestedList: true,
    primaryText: intl.formatMessage({
      id: 'administration'
    }),
    leftIcon: /*#__PURE__*/React.createElement(Security, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 129,
        columnNumber: 17
      }
    }),
    nestedItems: [{
      value: '/users',
      visible: isAuthorised,
      // In prod: isGranted('read_users'),
      primaryText: intl.formatMessage({
        id: 'users'
      }),
      leftIcon: /*#__PURE__*/React.createElement(GroupIcon, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 135,
          columnNumber: 21
        }
      })
    }, {
      value: '/roles',
      visible: isGranted('read_roles'),
      primaryText: intl.formatMessage({
        id: 'roles'
      }),
      leftIcon: /*#__PURE__*/React.createElement(AccountBoxIcon, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 141,
          columnNumber: 21
        }
      })
    }]
  }, {
    divider: true,
    visible: isAuthorised
  }, {
    primaryText: intl.formatMessage({
      id: 'settings'
    }),
    primaryTogglesNestedList: true,
    leftIcon: /*#__PURE__*/React.createElement(SettingsIcon, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 152,
        columnNumber: 17
      }
    }),
    nestedItems: [{
      primaryText: intl.formatMessage({
        id: 'theme'
      }),
      secondaryText: intl.formatMessage({
        id: themeSource.source
      }),
      primaryTogglesNestedList: true,
      leftIcon: /*#__PURE__*/React.createElement(StyleIcon, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 158,
          columnNumber: 21
        }
      }),
      nestedItems: themeItems
    }, {
      primaryText: intl.formatMessage({
        id: 'language'
      }),
      secondaryText: intl.formatMessage({
        id: locale
      }),
      primaryTogglesNestedList: true,
      leftIcon: /*#__PURE__*/React.createElement(LanguageIcon, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 165,
          columnNumber: 21
        }
      }),
      nestedItems: localeItems
    }]
  }, {
    onClick: () => {
      switchNightMode(!themeSource.isNightModeOn);
    },
    primaryText: intl.formatMessage({
      id: themeSource.isNightModeOn ? 'day_mode' : 'night_mode'
    }),
    leftIcon: themeSource.isNightModeOn ? /*#__PURE__*/React.createElement(Brightness7, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 175,
        columnNumber: 45
      }
    }) : /*#__PURE__*/React.createElement(Brightness2, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 175,
        columnNumber: 63
      }
    })
  }, {
    visible: isAppInstallable && !isAppInstalled,
    onClick: () => {
      deferredPrompt.prompt();
    },
    primaryText: intl.formatMessage({
      id: 'install'
    }),
    leftIcon: /*#__PURE__*/React.createElement(VerticalAlignBottomIcon, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 183,
        columnNumber: 17
      }
    })
  }];
};

export default getMenuItems;